import {MisName} from "../MisName";
import {MisDataServiceTypes} from "../SchoolMailroomConfigDto";

export enum BulkComparisonScenario
{
    "standard"="standard",
    "directIntegration"="directIntegration"
}

export interface BulkProcessorComparisonInput
{
    scenario: BulkComparisonScenario;
    
    //standard
    reloadConfig: boolean;
    
    //directIntegration
    targetMisDataServiceType: MisDataServiceTypes,
    misName: MisName;
}